/**
 * Message utilities for session card display.
 */
import type { Session } from './api';

const PREVIEW_MAX_CHARS = 80;

/**
 * Returns a display title for a session.
 * Fallback order: first words of first user message → "Conversa #<id-prefix>"
 */
export function getSessionTitle(session: Session): string {
  const firstUserMsg = session.messages?.find((m) => m.role === 'user');
  if (firstUserMsg?.content?.trim()) {
    const words = firstUserMsg.content.trim().split(/\s+/).slice(0, 5).join(' ');
    if (words) return words;
  }
  return `Conversa #${session.id.slice(0, 8)}`;
}

/**
 * Returns a prefixed preview of the last message, truncated to PREVIEW_MAX_CHARS.
 * Returns null when there are no messages.
 *
 * Examples:
 *   "Companion: Vou te ajudar com isso..."
 *   "Você: Como posso melhorar meu negocio?"
 */
export function getLastMessagePreview(session: Session): string | null {
  const messages = session.messages;
  if (!messages || messages.length === 0) return null;

  const lastMsg = messages[messages.length - 1];
  const prefix = lastMsg.role === 'assistant' ? 'Companion: ' : 'Você: ';
  const text = lastMsg.content.trim();
  const truncated =
    text.length > PREVIEW_MAX_CHARS ? text.slice(0, PREVIEW_MAX_CHARS) + '...' : text;

  return `${prefix}${truncated}`;
}
